import { render, staticRenderFns } from "./RecipientsReport.vue?vue&type=template&id=4e8bba12&"
import script from "./RecipientsReport.vue?vue&type=script&lang=js&"
export * from "./RecipientsReport.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsReport.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports